import { render, staticRenderFns } from "./ReservationTypeSelection.vue?vue&type=template&id=b9718eb4&scoped=true"
import script from "./ReservationTypeSelection.vue?vue&type=script&lang=js"
export * from "./ReservationTypeSelection.vue?vue&type=script&lang=js"
import style0 from "./ReservationTypeSelection.vue?vue&type=style&index=0&id=b9718eb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9718eb4",
  null
  
)

export default component.exports